import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatIconChevronRight } from '@blocks-react/components/Icons/ChevronRight';
import { CatButton } from '@blocks-react/components/Button';
import { OrderValueStatus } from '../types';
import styles from './OrderStatusFilter.module.scss';

interface OrderStatusFilterProps {
  orderStatusTitle: string;
  orderSelectedList?: OrderValueStatus[];
  handleClick: () => void;
  showLineAbove: boolean;
}
export const OrderStatusFilter: FC<OrderStatusFilterProps> = ({
  orderStatusTitle = '',
  orderSelectedList = [],
  handleClick,
  showLineAbove,
}) => {
  return (
    <div
      data-testid="order_statusr_container"
      className={`${
        showLineAbove
          ? styles['order_status_wrapper']
          : styles['order_status_iauser']
      } d-flex align-items-center justify-content-between mb-4`}
    >
      <div>
        <CatHeading variant="body-sm">{orderStatusTitle}</CatHeading>
        <div className={`${styles['order_statusr_list']}`}>
          <CatHeading variant="footnote">
            {orderSelectedList?.map((orderStatus: OrderValueStatus, index) =>
              index === orderSelectedList.length - 1
                ? orderStatus.label
                : `${orderStatus.label}, `
            )}
          </CatHeading>
        </div>
      </div>
      <CatButton hideText={true} variant="ghost" onClick={handleClick}>
        <CatIconChevronRight slot="before" aria-label={orderStatusTitle} />
      </CatButton>
    </div>
  );
};
